import { Link } from "react-router-dom";
import FaqCard from '@/components/shared/faq-card';
import GetContracts from '@/components/shared/get-contracts';
import SmallSpinner from '@/components/shared/spinners/small-spinner';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import AprilPicto from '@/components/shared/april-picto';
import { PictoConseils } from '@/assets/icons-april-fr/pictos';
import { getFaqByCategory, useFaq } from '@/hooks/api/use-faq';

/** FAQ du parrainage (catégorie 7). */
const ParrainagesFAQ = () => {
    const faq = useFaq();
    const faqs = getFaqByCategory(faq.data, 7);

    if (faq.isPending) {
        return <SmallSpinner />;
    }

    return (
        <GetContracts>
            <Card>
                <CardContent className="p-6">
                    <div className="flex items-center justify-center gap-2 mb-6">
                        <AprilPicto icon={PictoConseils} size="md" />
                        <h2 className="text-xl font-bold">
                            Tout savoir sur <strong className="text-primary">le parrainage</strong>
                        </h2>
                    </div>
                    {faqs.length > 0 &&
                        <div className="space-y-2">
                            {faqs.map((faq, index) => (
                                <FaqCard faq={faq} index={index} key={index}/>
                            ))}
                        </div>
                    }
                    <div className="mt-6 text-center">
                        <Button variant="outline" asChild className="cursor-pointer">
                            <Link to="/mes-questions" className="no-underline">
                                Voir toutes les questions
                            </Link>
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </GetContracts>
    )
}

export default ParrainagesFAQ
